import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import rtlPlugin from '@mui/stylis-plugin-rtl';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

const rtlCache = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer, rtlPlugin],
});

interface RTLCacheProviderProps {
  children: ReactNode;
}

export default function RTLCacheProvider({ children }: RTLCacheProviderProps) {
  const {
    i18n: { resolvedLanguage, dir },
  } = useTranslation(['manager']);

  if (dir(resolvedLanguage) === 'rtl') {
    return <CacheProvider value={rtlCache}>{children}</CacheProvider>;
  }

  return children;
}
